import { USER_TYPE } from '../../constants/userConstants';
var getUserType = function (userTypeValue, isCjOneMember) {
    var userType;
    switch (userTypeValue) {
        // CJ ONE 또는 TVING
        case '10': {
            userType = isCjOneMember ? USER_TYPE.CJ_ONE : USER_TYPE.TVING;
            break;
        }
        // CJ ONE
        case '30': {
            userType = USER_TYPE.CJ_ONE;
            break;
        }
        // TEST(?)
        case '40': {
            userType = USER_TYPE.TVING_TEST;
            break;
        }
        // TVING
        case '90': {
            userType = USER_TYPE.TVING;
            break;
        }
        // FACEBOOK
        case '91': {
            userType = USER_TYPE.FACEBOOK;
            break;
        }
        // TWITTER
        case '92': {
            userType = USER_TYPE.TWITTER;
            break;
        }
        // NAVER
        case '93': {
            userType = USER_TYPE.NAVER;
            break;
        }
        // TVING
        case '94': {
            userType = USER_TYPE.KAKAO;
            break;
        }
        // APPLE
        case '96': {
            userType = USER_TYPE.APPLE;
            break;
        }
        default: {
            throw new Error("Unknown User TYPE: ".concat(userTypeValue));
        }
    }
    return userType;
};
export default getUserType;
